import React from 'react';

import Card from './card';

// CSS imports (make sure the paths are correct)
import '../css/Repair.css';

// Importing images
import tradeInCard1 from "../images/boost5.svg";
import tradeInCard2 from "../images/build6.svg";
import tradeInCard3 from "../images/simplify7.svg";
import tradeInCard4 from "../images/optimize8.svg";

// Card data

const tradeInCards = [
  { image: tradeInCard1, title: "Boost Your Bottom Line", description: "Integrating buybacks creates a new revenue stream by allowing customers to trade in old devices, attracting new buyers and enabling resale of returned products." },
  { image: tradeInCard2, title: "Build Loyalty", description: "A buyback program fosters trust and loyalty, offering customers an easy upgrade path while earning credit for their old devices." },
  { image: tradeInCard3, title: "Simplify Processes", description: "Automated buyback integration reduces manual work and errors, handling instant quotes, and returns smoothly while keeping customer updated with real life notifications. " },
  { image: tradeInCard4, title: "Optimize Stock", description: "A buyback system lets you receive and refurbish used devices, helping reduce excess stock, improve turnover, and manage product life cycles more efficiently." },
];

const Repair = () => {

  return (
    <section className="bg-gradient-to-b from-gray-100 to-white py-16 px-6 bg-repair">
      <div className="text-center">
        <h2 className="text-3xl md:text-4xl font-medium text-[#3B2B52]">Designed for Trade-in and Buyback</h2>
        <p className="text-gray-600 mt-2 font-normal max-w-md mx-auto">
          Feature-packed platform to unify, simplify, and oversee your trade-in and buyback operations.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
        {tradeInCards.map((card, index) => (
          <Card key={index} imageUrl={card.image} title={card.title} description={card.description} />
        ))}
      </div>
    </section>
  );
};

export default Repair;
